
    /**
    * Gets normalized ratio of value inside range.
    */
    function norm(val, min, max){
        if (val < min || val > max) {
            throw new RangeError('value (' + val + ') must be between ' + min + ' and ' + max);
        }

        return val === max ? 1 : (val - min) / (max - min);
    }
    module.exports = norm;




//////////////////
// WEBPACK FOOTER
// ./node_modules/mout/math/norm.js
// module id = 551
// module chunks = 0